import { PageLayout } from '@/components/layout/PageLayout';
import { Routes } from '@/constants/routes';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import GetStarted from '@/pages/GetStarted';
import Home from '@/pages/Home';
import NotFound from '@/pages/NotFound';
import RouteError from '@/pages/RouteError';

export const appRoutes = [
  {
    element: <PageLayout />,
    errorElement: <RouteError />,
    children: [
      {
        errorElement: <RouteError />,
        children: [
          { index: true, element: <Home /> },
          { path: Routes.about, element: <About /> },
          { path: Routes.contact, element: <Contact /> },
          { path: Routes.getStarted, element: <GetStarted /> },
          { path: '*', element: <NotFound /> },
        ],
      },
    ],
  },
];